import React, { useEffect, useCallback } from 'react'
import { View, StyleSheet, Text, Image } from 'react-native'
import { useFocusEffect } from '@react-navigation/native';
import delay from 'delay'

import client, { useClient } from '@sart/client'
import { useContent } from '@sart/content'
import { adaptive, colors, typography } from '@sart/styles'
import {
	Button,
	Space,
	Title,
	WebView
} from '@sart/components'
import { updateNotifications, updateNotificationStatus, getNotificationType, testID } from '@sart/utilities'

const notificationRefreshTime = 10000
const defaultTimeLimit = 1000000

export default function Inbox(props) {
	const { navigation, route } = props
	const {
    cache: {
			username,
			customer,
      accounts,
			serviceLegacyId
    } = {}
  } = useClient()

  const content = useContent()
	var hasFocus = true
	const notification = route.params?.notification
	const basketRefId = route.params?.basketRefId
	const timeLimit = notification.completionTime !== undefined ? (notification.completionTime * 100) : defaultTimeLimit
	const notificationType = getNotificationType(notification)

	useEffect(() => {
    markAsSeen()
		checkNotificationStatus()
  }, [])

	useFocusEffect(
		useCallback(() => {
			hasFocus = true
			return () => {
				hasFocus = false
			}
		}, [])
	)

	async function markAsSeen() {
		if(notification.pac.status === 'new') {
			// We need to update the PAC (Page Access Control) for this notification to be 'seen'
			updateNotificationStatus(notification, 'seen')
		}
	}

	var startTime;

	async function checkNotificationStatus() {
		// We need to poll on the notification status
		var now = new Date()

		if (startTime === undefined) {
			startTime = Date.now()
		}

		try {
			if (notificationType === "QUESTIONNAIRE") {
				var latestPac = await client.callApi('contentCms', 'getPageAccessControls', [1, notification.pageId, { userId: client.cache.userId }])

				if (latestPac[0].status === 'completed') {
					console.log('completed');
					var navParams = {
						notification,
						basketRefId
					}
					if (basketRefId !== '') {
						// There is a basket ref id, so need to check the provisioning
						return navigation.navigate('NotificationProvisioning', navParams)
					} else {
						// Go to the confirmation screen
						return navigation.navigate('NotificationConfirmation', navParams)
					}
				}
			}
			if (!hasFocus) {
				return false
			} else if (now > new Date(notification.dateExpires)) {
				var navParams = {
					errorMessage: content.errors.notificationExpired
				}
				return navigation.navigate('NotificationError', navParams)
			} else if (startTime + timeLimit < Date.now()) {
				// Timeout, take the user to the error screen
				var navParams = {
					errorMessage: content.errors.notificationTimeout
				}
				return navigation.navigate('NotificationError', navParams)
			} else {
				await delay(notificationRefreshTime)
				checkNotificationStatus()
			}
		} catch (error) {
			// We need to check what the error is and then send it through to the error screen
			var navParams = {
				errorMessage: content.errors.notificationError
			}
			navigation.navigate('NotificationError', navParams)
		}

	}

	return (
		<View style={styles.container}>

			{ hasFocus && notification.href !== undefined && notification.href.length > 0 &&
				// Href is there, use that to open a WebView onto the href
				<WebView
					link={notification.href+'?field1=' + username + '&field2=' + customer.customerLegacyId + '&field3=' + accounts[0].accountLegacyId + '&field4=' + serviceLegacyId + '&field5=' + notification.legacyGroupId + '&field6=' + basketRefId}
					style={styles.webview}
					height={800}
					width={'100%'}
					keyboardDisplayRequiresUserAction={false}
					hideKeyboardAccessoryView={true}
				/>
			}
			{ hasFocus && (notification.href == undefined || notification.href === '') && 
				// No href, show the content of the notification
				<View style={styles.promoBody}>
					{notification.imageUrl !== undefined && [
						<Image 
							style={styles.justFlex}
							source={{uri:notification.imageUrl}}
						/>,
						<Space height={18}/>
					]}
					<View style={styles.justFlex}>
						<Title style={styles.title}>{notification.title}</Title>
						<Space height={18} />
						<Text>{notification.content}</Text>
						{ notificationType === "PROMOTION" && [
							<Space height={18} />,
							<Button
								title={content.inbox.promoClaim}
								onPress={() => {
									client.setCache({promoNotification:notification})
									navigation.navigate('Checkout')
								}}
								titleStyle={{...typography.extrabold, fontSize: 18, color: colors.white}}
								style={styles.button}
								{...testID('PromoButton')}
							/>
						]}
					</View>
				</View>
			}
		</View>
	)

}
const styles = StyleSheet.create({
  container: {
    flex: 1,
		backgroundColor:colors.white,
    ...adaptive.wrapperPadding
  },
	noNotifications: {
		textAlign:'center',
		fontSize:16,
		color:colors.feature,
		...typography.bold
	},
	webview: {
    // marginTop: 10,
    maxHeight: 800,
    ...adaptive.webViewWidth,
    flex: 1
  },
	timerStyle: {
		...typography.bold
	},
	title: {
    color: colors.srDarkGreen,
    ...typography.bold
  },
	promoBody: {
		flex:1,
		justifyContent:'center'
	},
	button: {
		marginHorizontal:32,
		backgroundColor: colors.srDarkGreen
	},
	justFlex: {
		flex:1
	}
})